var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWater = function SvgWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#water_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.283 12.605a7.16 7.16 0 0 1-6.672 7.377c-3.824.266-7.21-2.577-7.572-6.374-.181-1.894.287-3.674 1.055-5.387 1.163-2.592 2.93-4.78 4.759-6.925.313-.368.628-.736.955-1.092.239-.26.435-.275.658-.018 2.204 2.53 4.417 5.058 5.785 8.17.624 1.42 1.021 2.898 1.032 4.25ZM7.167 1.08c-.082.075-.119.1-.146.134-1.156 1.443-2.376 2.842-3.45 4.343C2.244 7.414 1.253 9.438.915 11.74c-.394 2.695.796 5.238 3.148 6.563 3.573 2.014 8.178.063 9.173-3.887.442-1.756.124-3.445-.494-5.098-.755-2.02-1.941-3.793-3.281-5.47-.742-.926-1.514-1.829-2.294-2.768Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.984 18.35H6.98c-1.763-.038-3.534-1.227-4.51-3.029-.865-1.595-.995-3.413-.347-4.864a.205.205 0 0 1 .27-.103c.103.045.15.164.104.267-.598 1.337-.473 3.023.333 4.509.908 1.675 2.54 2.78 4.159 2.815a.203.203 0 0 1 .2.206.204.204 0 0 1-.205.199Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "water_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14.286v20H0z"
  })))));
};
export default SvgWater;